import React, {Component} from 'react';
import {connect} from 'react-redux';
import CKEditor from 'react-ckeditor-component';
import ArrowButton from '../../button-arrow';
import './index.css';

class AdminEditor extends Component {
    state = {
      content: '',
      identifier: ''
    };

    handleClick = () => {
      this.props.dispatch(this.props.onClickAction({identifier: this.state.identifier, content: this.state.content}));
    }

    updateContent = (newContent) => {
      this.setState({
        content: newContent
      });
    };

    componentWillMount() {
      this.setState({
        identifier: this.props.identifier,
        content: this.props.content || ''
      });
    }

    render() {
      const {content, identifier} = this.state;
      const {editorTitle} = this.props;

      return (
        <div key={identifier} className='admin-editor' >
          {editorTitle && <h3>{editorTitle}</h3>}
          <CKEditor
            content={content}
            events={{
              change: event => this.updateContent(event.editor.getData())
          }}
          >
          </CKEditor>

          <ArrowButton
            className='float-right btn-block admin-editor-save'
            arrow={false}
            onClick={this.handleClick}
          >Save
          </ArrowButton>
        </div>
      );
    }
}

export default connect()(AdminEditor);



// WEBPACK FOOTER //
// ./src/components/common/editor/admin-editor/index.jsx